import {
  BrowserMessageReceiveType,
  BrowserMessageType,
  registerElectronMessageReceiver,
  sendElectronMessage,
} from 'electron-communication-lib/BrowserForApp';
import {useMountEffect} from 'webapp-lib/utils';

export const useHandleReloadRequested = (
  runPreconditionChecksAndReload: (onReload: () => void) => void
): void => {
  const sendReloadElectronMessage = (shift: boolean) => {
    sendElectronMessage({
      type: shift
        ? BrowserMessageType.SHIFT_RELOAD_WITHOUT_WEB_CHECK
        : BrowserMessageType.RELOAD_WITHOUT_WEB_CHECK,
      payload: null,
    });
  };

  const handleReloadRequested = (shift: boolean) => {
    runPreconditionChecksAndReload(() => {
      sendReloadElectronMessage(shift);
    });
  };

  useMountEffect(() => {
    registerElectronMessageReceiver(
      BrowserMessageReceiveType.RELOAD_REQUESTED,
      () => handleReloadRequested(false)
    );

    registerElectronMessageReceiver(
      BrowserMessageReceiveType.SHIFT_RELOAD_REQUESTED,
      () => handleReloadRequested(true)
    );
  });
};
